export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_RESPONSE = 'AUTH_LOGIN_RESPONSE';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR';
export const AUTH_LOGOUT_REQUEST = 'AUTH_LOGOUT_REQUEST';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
export const AUTH_LOGOUT_ERROR = 'AUTH_LOGOUT_ERROR';
export const AUTH_IDENTIFY_REQUEST = 'AUTH_IDENTIFY_REQUEST';
export const AUTH_IDENTIFY_SUCCESS = 'AUTH_IDENTIFY_SUCCESS';
export const AUTH_IDENTIFY_ERROR = 'AUTH_IDENTIFY_ERROR';
export const AUTH_GET_UI_CLIENT_REQUEST = 'AUTH_GET_UI_CLIENT_REQUEST';
export const AUTH_GET_UI_CLIENT_SUCCESS = 'AUTH_GET_UI_CLIENT_SUCCESS';
export const AUTH_GET_UI_CLIENT_ERROR = 'AUTH_GET_UI_CLIENT_ERROR';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const LOAD_CART_REQUEST = 'LOAD_CART_REQUEST';
export const LOAD_CART_SUCCESS = 'LOAD_CART_SUCCESS';
export const LOAD_CART_ERROR = 'LOAD_CART_ERROR';
export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR';
export const MODIFY_CART_GIFT_CARDS_REQUEST = 'MODIFY_CART_GIFT_CARDS_REQUEST';
export const MODIFY_CART_GIFT_CARDS_SUCCESS = 'MODIFY_CART_GIFT_CARDS_SUCCESS';
export const MODIFY_CART_GIFT_CARDS_ERROR = 'MODIFY_CART_GIFT_CARDS_ERROR';
export const REMOVE_FROM_CART_REQUEST = 'REMOVE_FROM_CART_REQUEST';
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_ERROR = 'REMOVE_FROM_CART_ERROR';
export const FORGET_CART = 'FORGET_CART';
export const PREPARE_CHECKOUT_REQUEST = 'PREPARE_CHECKOUT_REQUEST';
export const PREPARE_CHECKOUT_SUCCESS = 'PREPARE_CHECKOUT_SUCCESS';
export const PREPARE_CHECKOUT_ERROR = 'PREPARE_CHECKOUT_ERROR';
export const FINALIZE_CHECKOUT_REQUEST = 'FINALIZE_CHECKOUT_REQUEST';
export const FINALIZE_CHECKOUT_SUCCESS = 'FINALIZE_CHECKOUT_SUCCESS';
export const FINALIZE_CHECKOUT_ERROR = 'FINALIZE_CHECKOUT_ERROR';
export const MODIFY_CHECKOUT_REQUEST = 'MODIFY_CHECKOUT_REQUEST';
export const MODIFY_CHECKOUT_SUCCESS = 'MODIFY_CHECKOUT_SUCCESS';
export const MODIFY_CHECKOUT_ERROR = 'MODIFY_CHECKOUT_ERROR';
export const COMPLETE_CHECKOUT_STEP_REQUEST = 'COMPLETE_CHECKOUT_STEP_REQUEST';
export const COMPLETE_CHECKOUT_STEP_SUCCESS = 'COMPLETE_CHECKOUT_STEP_SUCCESS';
export const COMPLETE_CHECKOUT_STEP_ERROR = 'COMPLETE_CHECKOUT_STEP_ERROR';
export const ADD_PROMO_CODE_REQUEST = 'ADD_PROMO_CODE_REQUEST';
export const ADD_PROMO_CODE_SUCCESS = 'ADD_PROMO_CODE_SUCCESS';
export const ADD_PROMO_CODE_ERROR = 'ADD_PROMO_CODE_ERROR';
export const REMOVE_PROMO_CODE_REQUEST = 'REMOVE_PROMO_CODE_REQUEST';
export const REMOVE_PROMO_CODE_SUCCESS = 'REMOVE_PROMO_CODE_SUCCESS';
export const REMOVE_PROMO_CODE_ERROR = 'REMOVE_PROMO_CODE_ERROR';
export const TRACK_PRODUCT_CLICKED = 'TRACK_PRODUCT_CLICKED';
export const TRACK_COLLECTION_CLICKED = 'TRACK_COLLECTION_CLICKED';
export const TRACK_CART_VIEWED = 'TRACK_CART_VIEWED';
export const INITIALIZE_STATE_FROM_STORAGE = 'INITIALIZE_STATE_FROM_STORAGE';
export const MODIFY_CART_REQUEST = 'MODIFY_CART_REQUEST';
export const MODIFY_CART_SUCCESS = 'MODIFY_CART_SUCCESS';
export const MODIFY_CART_ERROR = 'MODIFY_CART_ERROR';
export const LOAD_USER_REFERRAL_IDENTIFIER_REQUEST = 'LOAD_USER_REFERRAL_IDENTIFIER_REQUEST';
export const LOAD_USER_REFERRAL_IDENTIFIER_SUCCESS = 'LOAD_USER_REFERRAL_IDENTIFIER_SUCCESS';
export const LOAD_USER_REFERRAL_IDENTIFIER_ERROR = 'LOAD_USER_REFERRAL_IDENTIFIER_ERROR';
export const ADD_SUBSCRIPTION_ERROR = 'ADD_SUBSCRIPTION_ERROR';
export const ADD_SUBSCRIPTION_SUCCESS = 'ADD_SUBSCRIPTION_SUCCESS';
export const ADD_SUBSCRIPTION_REQUEST = 'ADD_SUBSCRIPTION_REQUEST';
export const LOAD_SUBSCRIPTION_ERROR = 'LOAD_SUBSCRIPTION_ERROR';
export const LOAD_SUBSCRIPTION_SUCCESS = 'LOAD_SUBSCRIPTION_SUCCESS';
export const LOAD_SUBSCRIPTION_REQUEST = 'LOAD_SUBSCRIPTION_REQUEST';
export const LOAD_SUBSCRIPTIONS_ERROR = 'LOAD_SUBSCRIPTIONS_ERROR';
export const LOAD_SUBSCRIPTIONS_SUCCESS = 'LOAD_SUBSCRIPTIONS_SUCCESS';
export const LOAD_SUBSCRIPTIONS_REQUEST = 'LOAD_SUBSCRIPTIONS_REQUEST';
export const CANCEL_SUBSCRIPTION_ERROR = 'CANCEL_SUBSCRIPTION_ERROR';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_REQUEST = 'CANCEL_SUBSCRIPTION_REQUEST';
export const SKIP_SUBSCRIPTION_ERROR = 'SKIP_SUBSCRIPTION_ERROR';
export const SKIP_SUBSCRIPTION_SUCCESS = 'SKIP_SUBSCRIPTION_SUCCESS';
export const SKIP_SUBSCRIPTION_REQUEST = 'SKIP_SUBSCRIPTION_REQUEST';
export const UPDATE_SUBSCRIPTION_REQUEST = 'UPDATE_SUBSCRIPTION_REQUEST';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_ERROR = 'UPDATE_SUBSCRIPTION_ERROR';
export const RESUME_SUBSCRIPTION_REQUEST = 'RESUME_SUBSCRIPTION_REQUEST';
export const RESUME_SUBSCRIPTION_SUCCESS = 'RESUME_SUBSCRIPTION_SUCCESS';
export const RESUME_SUBSCRIPTION_ERROR = 'RESUME_SUBSCRIPTION_ERROR';
export const PAUSE_SUBSCRIPTION_REQUEST = 'PAUSE_SUBSCRIPTION_REQUEST';
export const PAUSE_SUBSCRIPTION_SUCCESS = 'PAUSE_SUBSCRIPTION_SUCCESS';
export const PAUSE_SUBSCRIPTION_ERROR = 'PAUSE_SUBSCRIPTION_ERROR';
export const LOAD_ORDER_ERROR = 'LOAD_ORDER_ERROR';
export const LOAD_ORDER_SUCCESS = 'LOAD_ORDER_SUCCESS';
export const LOAD_ORDER_REQUEST = 'LOAD_ORDER_REQUEST';
export const LOAD_ORDERS_ERROR = 'LOAD_ORDERS_ERROR';
export const LOAD_ORDERS_SUCCESS = 'LOAD_ORDERS_SUCCESS';
export const LOAD_ORDERS_REQUEST = 'LOAD_ORDERS_REQUEST';
export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_ERROR = 'LOAD_USER_ERROR';
export const MODIFY_USER_REQUEST = 'MODIFY_USER_REQUEST';
export const MODIFY_USER_SUCCESS = 'MODIFY_USER_SUCCESS';
export const MODIFY_USER_ERROR = 'MODIFY_USER_ERROR';
export const LOAD_USER_ADDRESS_BOOK_REQUEST = 'LOAD_USER_ADDRESS_BOOK_REQUEST';
export const LOAD_USER_ADDRESS_BOOK_SUCCESS = 'LOAD_USER_ADDRESS_BOOK_SUCCESS';
export const LOAD_USER_ADDRESS_BOOK_ERROR = 'LOAD_USER_ADDRESS_BOOK_ERROR';
export const MODIFY_USER_ADDRESS_BOOK_REQUEST = 'MODIFY_USER_ADDRESS_BOOK_REQUEST';
export const MODIFY_USER_ADDRESS_BOOK_SUCCESS = 'MODIFY_USER_ADDRESS_BOOK_SUCCESS';
export const MODIFY_USER_ADDRESS_BOOK_ERROR = 'MODIFY_USER_ADDRESS_BOOK_ERROR';
export const REMOVE_FROM_USER_ADDRESS_BOOK_REQUEST = 'REMOVE_FROM_USER_ADDRESS_BOOK_REQUEST';
export const REMOVE_FROM_USER_ADDRESS_BOOK_SUCCESS = 'REMOVE_FROM_USER_ADDRESS_BOOK_SUCCESS';
export const REMOVE_FROM_USER_ADDRESS_BOOK_ERROR = 'REMOVE_FROM_USER_ADDRESS_BOOK_ERROR';
export const LOAD_USER_STORE_CREDIT_EVENTS_REQUEST = 'LOAD_USER_STORE_CREDIT_EVENTS_REQUEST';
export const LOAD_USER_STORE_CREDIT_EVENTS_SUCCESS = 'LOAD_USER_STORE_CREDIT_EVENTS_SUCCESS';
export const LOAD_USER_STORE_CREDIT_EVENTS_ERROR = 'LOAD_USER_STORE_CREDIT_EVENTS_ERROR';
export const ASSOCIATE_CART_WITH_USER_REQUEST = 'ASSOCIATE_CART_WITH_USER_REQUEST';
export const ASSOCIATE_CART_WITH_USER_SUCCESS = 'ASSOCIATE_CART_WITH_USER_SUCCESS';
export const ASSOCIATE_CART_WITH_USER_ERROR = 'ASSOCIATE_CART_WITH_USER_ERROR';
export const LOAD_CATALOG_REQUEST = 'LOAD_CATALOG_REQUEST';
export const LOAD_CATALOG_SUCCESS = 'LOAD_CATALOG_SUCCESS';
export const LOAD_CATALOG_ERROR = 'LOAD_CATALOG_ERROR';
export const CREATE_STOCK_REQUEST_REQUEST = 'CREATE_STOCK_REQUEST_REQUEST';
export const CREATE_STOCK_REQUEST_SUCCESS = 'CREATE_STOCK_REQUEST_SUCCESS';
export const CREATE_STOCK_REQUEST_ERROR = 'CREATE_STOCK_REQUEST_ERROR';
export const GET_STATES_REQUEST = 'GET_STATES_REQUEST';
export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES_ERROR = 'GET_STATES_ERROR';
export const GET_USER_WALLET_REQUEST = 'GET_USER_WALLET_REQUEST';
export const GET_USER_WALLET_SUCCESS = 'GET_USER_WALLET_SUCCESS';
export const GET_USER_WALLET_ERROR = 'GET_USER_WALLET_ERROR';
export const UPDATE_ORDER_ADDRESSES_REQUEST = 'UPDATE_ORDER_ADDRESSES_REQUEST';
export const UPDATE_ORDER_ADDRESSES_SUCCESS = 'UPDATE_ORDER_ADDRESSES_SUCCESS';
export const UPDATE_ORDER_ADDRESSES_ERROR = 'UPDATE_ORDER_ADDRESSES_ERROR';
export const UPDATE_ORDER_DELIVERY_REQUEST = 'UPDATE_ORDER_DELIVERY_REQUEST';
export const UPDATE_ORDER_DELIVERY_SUCCESS = 'UPDATE_ORDER_DELIVERY_SUCCESS';
export const UPDATE_ORDER_DELIVERY_ERROR = 'UPDATE_ORDER_DELIVERY_ERROR';
export const UPDATE_ORDER_PAYMENT_REQUEST = 'UPDATE_ORDER_PAYMENT_REQUEST';
export const UPDATE_ORDER_PAYMENT_SUCCESS = 'UPDATE_ORDER_PAYMENT_SUCCESS';
export const UPDATE_ORDER_PAYMENT_ERROR = 'UPDATE_ORDER_PAYMENT_ERROR';
export const TRACK_EMAIL_CAPTURED = 'TRACK_EMAIL_CAPTURED';
export const TRACK_PRODUCT_VIEWED = 'TRACK_PRODUCT_VIEWED';
export const TRACK_VARIANT_CLICKED = 'TRACK_VARIANT_CLICKED';
export const CROSS_SELL_ERROR = 'CROSS_SELL_ERROR';
export const CROSS_SELL_SUCCESS = 'CROSS_SELL_SUCCESS';
export const CROSS_SELL_REQUEST = 'CROSS_SELL_REQUEST';
export const MODIFY_CART_LINE_ITEM_REQUEST = 'MODIFY_CART_LINE_ITEM_REQUEST';
export const MODIFY_CART_LINE_ITEM_SUCCESS = 'MODIFY_CART_LINE_ITEM_SUCCESS';
export const MODIFY_CART_LINE_ITEM_ERROR = 'MODIFY_CART_LINE_ITEM_ERROR';
export const PURCHASE_PREPAID_SUBSCRIPTION_REQUEST = 'PURCHASE_PREPAID_SUBSCRIPTION_REQUEST';
export const PURCHASE_PREPAID_SUBSCRIPTION_SUCCESS = 'PURCHASE_PREPAID_SUBSCRIPTION_SUCCESS';
export const PURCHASE_PREPAID_SUBSCRIPTION_ERROR = 'PURCHASE_PREPAID_SUBSCRIPTION_ERROR';
export const GET_STOCK_AVAILABILITY_REQUEST = 'GET_STOCK_AVAILABILITY_REQUEST';
export const GET_STOCK_AVAILABILITY_SUCCESS = 'GET_STOCK_AVAILABILITY_SUCCESS';
export const GET_STOCK_AVAILABILITY_ERROR = 'GET_STOCK_AVAILABILITY_ERROR';
export const CHECK_REDEMPTION_CODE_VALIDITY_REQUEST = 'CHECK_REDEMPTION_CODE_VALIDITY_REQUEST';
export const CHECK_REDEMPTION_CODE_VALIDITY_SUCCESS = 'CHECK_REDEMPTION_CODE_VALIDITY_SUCCESS';
export const CHECK_REDEMPTION_CODE_VALIDITY_ERROR = 'CHECK_REDEMPTION_CODE_VALIDITY_ERROR';
export const REDEEM_GIFT_CARD_REQUEST = 'REDEEM_GIFT_CARD_REQUEST';
export const REDEEM_GIFT_CARD_SUCCESS = 'REDEEM_GIFT_CARD_SUCCESS';
export const REDEEM_GIFT_CARD_ERROR = 'REDEEM_GIFT_CARD_ERROR';
export const REDEEM_PREPAID_SUBSCRIPTION_REQUEST = 'REDEEM_PREPAID_SUBSCRIPTION_REQUEST';
export const REDEEM_PREPAID_SUBSCRIPTION_SUCCESS = 'REDEEM_PREPAID_SUBSCRIPTION_SUCCESS';
export const REDEEM_PREPAID_SUBSCRIPTION_ERROR = 'REDEEM_PREPAID_SUBSCRIPTION_ERROR';
export const GET_PRICE_REQUEST = 'GET_PRICE_REQUEST';
export const GET_PRICE_SUCCESS = 'GET_PRICE_SUCCESS';
export const GET_PRICE_ERROR = 'GET_PRICE_ERROR';
export const EMPTY_CART_REQUEST = 'EMPTY_CART_REQUEST';
export const EMPTY_CART_SUCCESS = 'EMPTY_CART_SUCCESS';
export const EMPTY_CART_ERROR = 'EMPTY_CART_ERROR';
export const CALCULATE_SHIPPING_OPTIONS_REQUEST = 'CALCULATE_SHIPPING_OPTIONS_REQUEST';
export const CALCULATE_SHIPPING_OPTIONS_SUCCESS = 'CALCULATE_SHIPPING_OPTIONS_SUCCESS';
export const CALCULATE_SHIPPING_OPTIONS_ERROR = 'CALCULATE_SHIPPING_OPTIONS_ERROR';
export const APPLY_GIFT_CARD_REQUEST = 'APPLY_GIFT_CARD_REQUEST';
export const APPLY_GIFT_CARD_SUCCESS = 'APPLY_GIFT_CARD_SUCCESS';
export const APPLY_GIFT_CARD_ERROR = 'APPLY_GIFT_CARD_ERROR';
export const REMOVE_GIFT_CARD_REQUEST = 'REMOVE_GIFT_CARD_REQUEST';
export const REMOVE_GIFT_CARD_SUCCESS = 'REMOVE_GIFT_CARD_SUCCESS';
export const REMOVE_GIFT_CARD_ERROR = 'REMOVE_GIFT_CARD_ERROR';
const status = {
  Idle: 'idle',
  Initial: 'initial',
  Failed: 'failed',
  Loading: 'loading',
  Succeeded: 'succeeded'
};
export const AuthStatus = status;
export const UserStatus = status;